/** Match the visible price bar to the existing price radio without changing facet values. */
export function priceFilterAmounts(label: string, frenchWatchDiscovery = false): string {
  let value = label.toLowerCase();
  if (frenchWatchDiscovery) {
    // French thousands use spaces, NBSP or narrow NBSP. Only remove a space
    // between groups of digits, never a range separator or unrelated wording.
    let previous: string;
    do { previous = value; value = value.replace(/(\d)[ \u00a0\u202f]+(?=\d{3}(?:\D|$))/g, '$1'); }
    while (value !== previous);
    value = value.replace(/(\d),(\d+)(?=\s*k\b)/g, '$1.$2');
  }
  const normalized = value.replace(/(\d+(?:\.\d+)?)k/g, (_, n) => String(Number(n) * 1000));
  const nums = (normalized.match(/\d[\d,]*/g) || []).map(n => Number(n.replace(/,/g, ''))).filter(n => n > 0);
  return nums.sort((a, b) => a - b).join('-');
}
